const PrivacyPolicyModal = ({ onClose }: { onClose: () => void }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 p-4">
    <div className="bg-white rounded-xl shadow-lg max-w-4xl w-full max-h-[90vh] overflow-hidden relative">
      <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex justify-between items-center">
        <h2 className="text-2xl font-display font-bold text-gray-900">Privacy Policy</h2>
        <button
          className="text-gray-500 hover:text-accent text-2xl font-bold w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
      </div>
      <div className="p-6 overflow-y-auto max-h-[calc(90vh-80px)]">
        <div className="text-gray-700 space-y-6 text-sm leading-relaxed text-left">
          <p className="text-gray-600 mb-6">
            <strong>Effective Date:</strong> September 8, 2025
          </p>
          
          <p>
            Welcome to our website ("Site"). Alt Dev Studios ("Company," "we," "our," or "us") values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard information when you interact with our Site. By using our Site, you agree to the practices described in this Policy.
          </p>

          <div>
            <h3 className="text-lg font-display font-bold text-gray-900 mb-3">1. Personally Identifiable Information</h3>
            <div className="space-y-3">
              <p>
                We may collect and store information that specifically identifies you ("Personally Identifiable Information") if you voluntarily provide it. This may include your name, email address, physical address, or other details.
              </p>
              <p>
                Information collected through the Site may be cross-referenced with other online and offline sources.
              </p>
              <p>We use this information to:</p>
              <ul className="list-disc ml-6 space-y-1">
                <li>Respond to inquiries</li>
                <li>Provide requested services</li>
                <li>Communicate about our products</li>
                <li>Deliver relevant updates and messages</li>
              </ul>
              <p>
                We do not sell or share your Personally Identifiable Information with third parties without your consent.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-display font-bold text-gray-900 mb-3">2. Non-Personally Identifiable Information</h3>
            <div className="space-y-3">
              <p>
                We may automatically collect anonymous data about your interactions with the Site through cookies and similar technologies.
              </p>
              <p>
                This may include browsing habits, device type, demographics, and referral sources.
              </p>
              <p>
                Non-identifiable information may be aggregated and shared with third parties for analytics, advertising, or service improvements.
              </p>
              <p>
                We may also disclose information as required by law, to comply with court orders, or to investigate suspected fraud or misuse.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-display font-bold text-gray-900 mb-3">3. Cookies and Tracking Technologies</h3>
            <div className="space-y-3">
              <p>
                Cookies are small data files stored on your device to help customize your experience, track return visits, and tailor communications.
              </p>
              <p>
                Most browsers accept cookies automatically, but you can change your settings to block or receive alerts about them. Please note: disabling cookies may affect certain Site features.
              </p>
              <p>
                Third-party advertisers and service providers may also place cookies when you interact with their content on our Site. Their use of data is governed by their own privacy policies, not ours.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-display font-bold text-gray-900 mb-3">4. Opt-Out Procedures</h3>
            <div className="space-y-3">
              <p>
                You may opt out of receiving promotional emails from Alt Dev Studios by following the unsubscribe instructions included at the bottom of each message.
              </p>
              <p>
                Even if you opt out, we may retain your information for legitimate business purposes such as recordkeeping, compliance with legal obligations, or service-related communications.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-display font-bold text-gray-900 mb-3">5. Links to Third-Party Websites</h3>
            <div className="space-y-3">
              <p>
                Our Site may contain links to external websites operated by third parties.
              </p>
              <p>
                We are not responsible for the privacy practices, content, or policies of those third-party websites.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-display font-bold text-gray-900 mb-3">6. Contact Us</h3>
            <div className="space-y-3">
              <p>
                If you have questions about this Privacy Policy or the Terms of Service for our Site, you may contact us at:
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold">Alt Dev Studios</p>
                <p><a href="mailto:info@altdevstudios.com" className="text-primary hover:text-accent underline">info@altdevstudios.com</a></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PrivacyPolicyModal;
